import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./styles/SiteManager.css";
import { AuthContext } from "../context/AuthContext";
import customerlogo from "./assets/ajay.jpeg";
export default function SiteManager({ onSiteCreated }) {
  const [sites, setSites] = useState([]);
  const [masterSites, setMasterSites] = useState([]);
  const [form, setForm] = useState({
    name: "",
    phoneNumber: "",
    dispenserType: "",
    latitude: "",
    longitude: "",
    masterSiteId: "",
  });
  const [editingId, setEditingId] = useState(null);

  const token = localStorage.getItem('token'); 
  const { user } = useContext(AuthContext);  // ✅ Get user from AuthContext
  const isAdmin = user?.role === "admin";

  const authHeader = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const selectedMasterSite = masterSites.find(ms => ms._id === form.masterSiteId);

  const fetchSites = async () => {
    const res = await axios.get("/api/sites", authHeader);
    setSites(res.data);
  };

  const fetchMasterSites = async () => {
    const res = await axios.get("/api/mastersites", authHeader);
    setMasterSites(res.data);
  };

  useEffect(() => {
    fetchSites();
    fetchMasterSites();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form };
    if (editingId) {
      await axios.put(`/api/sites/${editingId}`, payload, authHeader);
    } else {
      await axios.post("/api/sites", payload, authHeader);
      if (onSiteCreated) onSiteCreated();
    }
    setForm({ name: "", phoneNumber: "", dispenserType: "", latitude: "", longitude: "", masterSiteId: "" });
    setEditingId(null);
    fetchSites();
  };

  const handleEdit = (site) => {
    setEditingId(site._id);
    setForm({
      name: site.name,
      phoneNumber: site.phoneNumber,
      dispenserType: site.dispenserType,
      latitude: site.latitude,
      longitude: site.longitude,
      masterSiteId: site.masterSiteId,
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this site?")) {
      await axios.delete(`/api/sites/${id}`, authHeader);
      fetchSites();
    }
  };

  return (
    <div className="site-manager-container">
      {isAdmin && (
        <div className="site-form">
          <h2>{editingId ? "Edit Site" : "Add Site"}</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Site Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Phone Number"
              value={form.phoneNumber}
              onChange={(e) => setForm({ ...form, phoneNumber: e.target.value })}
            />
            <input
              type="text"
              placeholder="Latitude"
              value={form.latitude}
              onChange={(e) => setForm({ ...form, latitude: e.target.value })}
            />
            <input
              type="text"
              placeholder="Longitude"
              value={form.longitude}
              onChange={(e) => setForm({ ...form, longitude: e.target.value })}
            />
            <select
              value={form.masterSiteId || ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                const master = masterSites.find((ms) => ms._id === selectedId);
                setForm({
                  ...form,
                  masterSiteId: selectedId,
                  dispenserType: master?.dispenserType || "",
                });
              }}
            >
              <option value="">Select Master Site</option>
              {masterSites.map((ms) => (
                <option key={ms._id} value={ms._id}>
                  {ms.name}
                </option>
              ))}
            </select>

            {selectedMasterSite && (
              <div className="site-info">
                <strong>Dispenser Type:</strong> {selectedMasterSite.dispenserType}
              </div>
            )}

            <button type="submit">
              {editingId ? "Update" : "Add"}
            </button>
          </form>
        </div>
      )}

      <h2 className="site-list-title">Existing Sites</h2>
      <table className="site-list">
        <thead>
          <tr>
            <th>Site Name</th>
            <th>Phone</th>
            {isAdmin && <th>Latitude</th>}
            {isAdmin && <th>Longitude</th>}
            {isAdmin && <th>Dispenser</th>}
            <th>Master Site</th>
            {isAdmin && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {sites.map((site) => {
            const master = masterSites.find((m) => m._id === site.masterSiteId);
            return (
              <tr key={site._id}>
                <td>{site.name}</td>
                <td>{site.phoneNumber}</td>
                {isAdmin && <td>{site.latitude || "-"}</td>}
                {isAdmin && <td>{site.longitude || "-"}</td>}
                {isAdmin && <td>{site.dispenserType}</td>}
                <td>{master?.name || "—"}</td>
                {isAdmin && (
                  <td className="action-buttons">
                    <button className="edit-btn" onClick={() => handleEdit(site)}>Edit</button>
                    <button className="delete-btn" onClick={() => handleDelete(site._id)}>Delete</button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
